export default "__VITE_ASSET__D84DBLhl__"